define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/action/Controller",
	"csi/locale",
	"csi/message",
	"csi/comm/PostRequest",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(declare,lang,_,Controller,locale,message,PostRequest,MessageDialog,xml) {

	return declare(Controller, {
		bPushProductsToSalesMarkets: false,

		process: function() {
			var state = xml.enumGetText(this.getNode().State);

			var missingProducts = _.filter(this.getNode().LookProducts, function(lookProduct){
				return !_.contains(this.getNode().SalesLooks, lookProduct);
			}, this);

			if ((state == "ReleaseToCustomers" || state == "ReleaseToMarkets") && missingProducts.length > 0) {
				this.confirmAction({
					buttons: [MessageDialog.BUTTON_YES, MessageDialog.BUTTON_NO + MessageDialog.BUTTON_PRIMARY, MessageDialog.BUTTON_CANCEL]
				});
			} else {
				this.inherited(arguments);
			}
		},

		onConfirm: function(/*String*/key) {
			if (key == "C") {
				this.postProcess();
			} else {
				this.bPushProductsToSalesMarkets = (key == "Y");
				Controller.prototype.process.call(this);
			}
		},

		_hasReturnNodeRequest: function() {
			return this.bPushProductsToSalesMarkets;
		},

		getSuccess: function() {
			return this.bPushProductsToSalesMarkets ? locale.typeAction(this.getNode().$Type,"PushProductsToSalesMarket_Success", this.getStringParameters()) : this.inherited(arguments);
		},

		getReturnNodeRequest: function() {
			return new PostRequest("CollectionBook", "MLPushProductsToSalesLooks")
				.addParameter("ParentURL", this.m_urlNode)
				.addParameter("URLs", this.getNode().SalesLooks);
		},

		postProcessSuccess: function() {
			if (this.widget.postActionState) {
				this.widget.postActionState(this);
			} else {
				this.widget.postActionRedrawNode(this);
			}
		},

		_writeRequestParameters: function(/*CallMethod*/call) {
			// summary: add standard parameters to CallMethod operation
			this.inherited(arguments);

			if (this.getNode().$Type == "MarketingLook") {
				call.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, this.m_urlNode); //A work around for DE29948
			}
		}
	});
});